import { render, staticRenderFns } from "./CalendarEventItem.vue?vue&type=template&id=3cb4a339&"
import script from "./CalendarEventItem.vue?vue&type=script&lang=js&"
export * from "./CalendarEventItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports